export default __webpack_public_path__ + "static/PPEditorialNew-LightItalic-cd7919d34857972a59d4aed3ba0f46af.woff2";